import type { ReactNode } from 'react';
import { NotImplementedHint } from './PayRunNotImplemented';

/**
 * Completed runs expose their existing payment output, pay advice, and payslip controls here.
 * Other report content remains TBC in the Jira description, so an unfinished run keeps the
 * reserved design placeholder instead of inventing report data.
 */
export const PayRunReportsTab = ({ children }: { children?: ReactNode }) => (
  <div className="mgo-stack mgo-gap-l" data-testid="pay-run-reports-tab">
    {children || (
      <div className="mgo-cluster mgo-gap-s mgo-align-center">
        <span className="mgo-text-m mgo-weight-strong">Reports</span>
        <NotImplementedHint
          what="Pay run reports"
          because="This tab is reserved by the approved design; its contents are not defined yet."
          testId="pay-run-reports-hint"
        />
      </div>
    )}
  </div>
);
